var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DatepickerCustomHeader } from '@web/components/layout/DatePicker/RangeDatePicker';
import { cx } from '@web/utility';
import { useFilters } from '@web/utility/hooks/useFilters';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { format } from 'date-fns';
import DatePicker from 'react-datepicker';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
export function SingleDayFilter(_a) {
    var _b = _a.isDisplayLabel, isDisplayLabel = _b === void 0 ? true : _b, _c = _a.dateKey, dateKey = _c === void 0 ? 'dateFrom' : _c, _d = _a.variant, variant = _d === void 0 ? 'stacked' : _d;
    var navigateTo = useNavigateTo();
    var location = useLocation();
    var t = useTranslation().t;
    var filters = useFilters();
    var selectedDate = dateKey === 'driveTimelineDate'
        ? filters.driveTimelineDate
        : filters.dateFrom;
    var isInline = variant === 'inline';
    var onChange = function (date) {
        var formattedDate = format(date, 'yyyy-MM-dd');
        navigateTo({
            pathname: location.pathname,
            newFilters: dateKey === 'driveTimelineDate'
                ? { driveTimelineDate: formattedDate }
                : {
                    dateFrom: formattedDate,
                    dateTo: formattedDate
                }
        });
    };
    return (_jsxs("div", __assign({ className: cx(isInline ? 'flex items-center gap-2' : 'w-full sm:max-w-72'), id: "root-portal" }, { children: [isDisplayLabel && (_jsx("label", __assign({ className: cx('text-sm font-medium leading-6 text-gray-900', isInline ? 'whitespace-nowrap' : 'block') }, { children: t('filters.selectDate') }))), _jsx(DatePicker, { selected: new Date(selectedDate), onChange: function (date) { return date && onChange(date); }, dateFormat: "yyyy-MM-dd", shouldCloseOnSelect: true, className: cx('relative cursor-pointer', isInline ? 'w-[7.5rem]' : 'w-full'), wrapperClassName: cx(isInline ? 'w-auto' : 'w-full mt-2'), popperClassName: "z-50", portalId: "root-portal", onKeyDown: function (e) { return e.preventDefault(); }, renderCustomHeader: function (_a) {
                    var date = _a.date, decreaseMonth = _a.decreaseMonth, increaseMonth = _a.increaseMonth, prevMonthButtonDisabled = _a.prevMonthButtonDisabled, nextMonthButtonDisabled = _a.nextMonthButtonDisabled;
                    return (_jsx(DatepickerCustomHeader, { date: date, decreaseMonth: decreaseMonth, increaseMonth: increaseMonth, prevMonthButtonDisabled: prevMonthButtonDisabled, nextMonthButtonDisabled: nextMonthButtonDisabled }));
                }, customInput: _jsx("input", { className: "caret-transparent" }) })] })));
}
